import { v4 as uuid } from 'uuid';
import { compact, map } from 'lodash';
import { toUUID } from '../../util/transform';
import HomeLoanReviewProductSplit from './HomeLoanReviewProductSplit';
import type { IHomeLoanReviewProduct } from './HomeLoanReviewProduct.interface';

export default class HomeLoanReviewProduct implements IHomeLoanReviewProduct {
  id: string;
  idLender: string;
  lenderTurnaround: number;
  productSplits: Array<HomeLoanReviewProductSplit>;
  isPreferred: boolean;

  static build = (data: IHomeLoanReviewProduct) => new HomeLoanReviewProduct(data);
  static blank = () => new HomeLoanReviewProduct();

  /**
   * Constructor
   * @param {IHomeLoanReviewProduct} data
   */
  constructor(data?: IHomeLoanReviewProduct) {
    this.id = toUUID(data?.id) || uuid();
    this.idLender = data?.idLender || '';
    this.lenderTurnaround = data?.lenderTurnaround || 0;
    this.productSplits = map(
      compact(data?.productSplits),
      (obj) => new HomeLoanReviewProductSplit(obj)
    );
    this.isPreferred = data?.isPreferred === true;
  }
}
